import React from "react";
import { netDelta, primaryOwner } from "../format";
import { fmtSignedMoney, fmtPct } from "../format";

// One CFO-ready strip: Change / Run-rate / Primary driver / Primary owner / Confidence.
export default function CaseSummaryStrip({ inv, version, ownership = [] }) {
  const drivers = version?.drivers || [];
  const net = netDelta(drivers);
  const runRate = version?.impact?.monthlyRunRateDelta;
  const top = [...drivers].sort((a, b) => Math.abs(b.deltaCost) - Math.abs(a.deltaCost))[0];
  const owner = primaryOwner(ownership);
  const cells = [
    { k: "Change", v: fmtSignedMoney(net), strong: true },
    { k: "Run-rate impact", v: runRate != null ? `${fmtSignedMoney(runRate)}/mo` : "—", strong: true },
    { k: "Primary driver", v: top ? `${top.label || top.key}` : "—", sub: top ? `${fmtPct(top.sharePct)} of change` : "" },
    { k: "Primary owner", v: owner ? owner.label : "—", sub: owner ? fmtSignedMoney(owner.deltaCost) : "" },
    { k: "Confidence", v: inv?.confidenceLabel || "—" },
  ];
  return (
    <div className="grid grid-cols-2 gap-px overflow-hidden rounded-card border border-card-bd bg-card-bd sm:grid-cols-3 lg:grid-cols-5">
      {cells.map((c) => (
        <div key={c.k} className="bg-card px-4 py-3">
          <div className="text-[11px] font-medium uppercase tracking-wide text-text-3">{c.k}</div>
          <div className={`mt-1 tabular-nums ${c.strong ? "text-[18px] font-semibold text-text" : "text-[14px] font-medium text-text-2"}`}>{c.v}</div>
          {c.sub ? <div className="text-[12px] tabular-nums text-text-3">{c.sub}</div> : null}
        </div>
      ))}
    </div>
  );
}
